import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgRead = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 12" {...props}>
    <path
      d="m.563 5.77 5.578 5.75L14.6.063M9.42 9.745l1.72 1.775L19.603.063"
      fill="none"
      stroke="#22B035"
    />
  </svg>
);
const Memo = memo(SvgRead);
export default Memo;
